import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Navimumbaiairportcabservice() {



  const cardData = {
    keyword: " Navi Mumbai Airport Cab Service  ",


"headingDescription": "Royal Route Cab offers professional Navi Mumbai Airport cab service, providing safe, punctual, and affordable transportation for airport pickups, drops, local travel, corporate transfers, and outstation journeys. Whether you are traveling for business, family trips, or daily commute, our experienced drivers and well-maintained vehicles ensure a smooth and stress-free ride. We specialize in timely airport transfers with real-time flight tracking, luggage assistance, and doorstep pickup across Navi Mumbai, Mumbai, and nearby areas. Our fleet includes air-conditioned sedans, SUVs, Innova, Ertiga, Kia Carens, Innova Crysta, and Tempo Travellers suitable for individuals and groups. With 24/7 availability, transparent pricing, and easy booking, Royal Route Cab is a trusted choice for Navi Mumbai Airport cab service.",

"topPlaces": [
  {
    "title": "Airport Pickup Service",
    "description": "Navi Mumbai Airport pickup service ensures passengers are received on time with professional drivers waiting at designated points. Flight tracking helps adjust pickup timing in case of delays, while luggage assistance and comfortable vehicles make arrivals smooth and stress-free, especially after long journeys."
  },
  {
    "title": "Airport Drop Service",
    "description": "Airport drop service provides timely departures with proper route planning to avoid traffic delays. Drivers ensure passengers reach the airport well before their flight schedule, making it a reliable option for business travelers, families, and frequent flyers."
  },
  {
    "title": "Inter-Airport Transfers",
    "description": "Travelers often require transfers between Navi Mumbai Airport and Mumbai International Airport. Cab services provide seamless connectivity between both airports with comfortable vehicles and experienced drivers ensuring timely travel for connecting flights."
  },
  {
    "title": "Local Navi Mumbai Rides",
    "description": "Cab services are widely used for local travel across Navi Mumbai including Vashi, Nerul, Belapur, Kharghar, Panvel, and Airoli. They offer convenient, safe, and time-saving transportation for office commute, shopping, and daily travel needs."
  },
  {
    "title": "Corporate Travel Solutions",
    "description": "Corporate airport cab services provide professional and punctual transport for business executives, employees, and clients. Clean vehicles, trained drivers, and reliable scheduling make them ideal for meetings, conferences, and official travel."
  },
  {
    "title": "Outstation Travel from Airport",
    "description": "Passengers can directly book cabs from Navi Mumbai Airport to destinations like Pune, Lonavala, Nashik, Shirdi, Surat, and other cities. This eliminates the need for multiple bookings and offers a smooth long-distance travel experience."
  },
  {
    "title": "Family & Group Travel",
    "description": "For families and group travelers, larger vehicles such as Innova, Ertiga, and Tempo Travellers are available, offering spacious seating and luggage capacity. This ensures a comfortable and convenient airport journey without splitting into multiple vehicles."
  },
  {
    "title": "24/7 Cab Availability",
    "description": "Navi Mumbai Airport cab services operate round the clock, making them suitable for early morning departures, late-night arrivals, and emergency travel. Reliable availability ensures passengers always have access to transportation whenever needed."
  },
  {
    "title": "Luxury Airport Transfers",
    "description": "Premium vehicles like Innova Crysta and Kia Carens are available for travelers seeking a more comfortable and stylish airport transfer experience. These vehicles provide enhanced interiors, smooth rides, and a premium travel feel."
  },
  {
    "title": "Safe & Hygienic Travel",
    "description": "Cab services follow strict safety and cleanliness standards, including sanitized vehicles, verified drivers, and secure travel practices. This ensures passengers enjoy a safe and comfortable ride to and from Navi Mumbai Airport."
  }
],






services: [
  {
    name: "Navi Mumbai Airport Cab Service",
    description: "Navi Mumbai airport cab service offers reliable and comfortable transportation for timely airport transfers. Ideal for individuals, families, and business travelers, this service ensures punctual pickup and drop. Professional drivers and clean vehicles enhance comfort. It guarantees a smooth and stress-free airport journey."
  },
  {
    name: "Navi Mumbai Airport Taxi Service",
    description: "Navi Mumbai airport taxi service provides convenient and private travel with door-to-door pickup. This service is perfect for airport transfers with flexible scheduling. Comfortable vehicles ensure a pleasant ride. It guarantees hassle-free travel."
  },
  {
    name: "Airport Cab Service Navi Mumbai",
    description: "Airport cab service Navi Mumbai ensures timely and efficient transportation to and from the airport. This service is ideal for flight travelers needing dependable rides. Professional drivers ensure safety. It guarantees a smooth experience."
  },
  {
    name: "Navi Mumbai Airport Taxi",
    description: "Navi Mumbai airport taxi offers quick and reliable rides for airport transfers. This service is ideal for both arrivals and departures. Flexible booking options enhance convenience. It ensures a comfortable journey."
  },
  {
    name: "Navi Mumbai Airport Cab",
    description: "Navi Mumbai airport cab provides easy and convenient travel with well-maintained vehicles and experienced drivers. This service is suitable for all types of travelers. It ensures a safe and comfortable airport transfer."
  },
  {
    name: "Book Cab Service for Navi Mumbai Airport",
    description: "Book cab service for Navi Mumbai airport with quick online booking and instant confirmation. Customers can select vehicle type, pickup time, and location easily. Transparent pricing ensures trust. It simplifies airport travel planning."
  },
  {
    name: "Online Navi Mumbai Airport Cab Service",
    description: "Online Navi Mumbai airport cab service provides a fast and convenient way to reserve rides. Secure payment and instant confirmation enhance booking experience. Multiple vehicle options are available. It ensures hassle-free booking."
  },
  {
    name: "Best Cab Service Navi Mumbai Airport",
    description: "Best cab service Navi Mumbai airport ensures top-quality vehicles, professional drivers, and excellent customer support. This service focuses on punctuality, safety, and comfort. It guarantees a premium airport travel experience."
  },
  {
    name: "Reliable Airport Cab Service Navi Mumbai",
    description: "Reliable airport cab service Navi Mumbai offers dependable transportation with verified drivers and well-maintained vehicles. This service ensures timely pickups and drops. It guarantees a safe and comfortable journey."
  },
  {
    name: "Cheapest Cab Service Navi Mumbai Airport",
    description: "Cheapest cab service Navi Mumbai airport offers budget-friendly travel without compromising on comfort. Transparent pricing ensures no hidden charges. Ideal for cost-conscious travelers. It ensures economical airport transfers."
  },
  {
    name: "24x7 Navi Mumbai Airport Cab Service",
    description: "24x7 Navi Mumbai airport cab service provides round-the-clock availability for all travel needs. This service is ideal for late-night and early morning flights. Quick booking ensures convenience. It guarantees service anytime."
  },
  {
    name: "Late Night Airport Cab Service Navi Mumbai",
    description: "Late night airport cab service Navi Mumbai ensures safe and reliable transportation during late hours. Professional drivers and secure rides enhance safety. It is ideal for night travelers. It guarantees peace of mind."
  },
  {
    name: "Early Morning Airport Taxi Navi Mumbai",
    description: "Early morning airport taxi Navi Mumbai offers timely pickup for early flights. This service ensures punctual arrival at the airport. Comfortable vehicles enhance travel experience. It guarantees a stress-free journey."
  },
  {
    name: "Corporate Cab Service Navi Mumbai Airport",
    description: "Corporate cab service Navi Mumbai airport provides professional travel solutions for business clients. This service includes punctual pickups, clean vehicles, and trained drivers. It ensures efficient corporate travel."
  },
  {
    name: "Luxury Airport Cab Service Navi Mumbai",
    description: "Luxury airport cab service Navi Mumbai offers premium vehicles for high-end travel. Ideal for executives and VIP clients. Comfortable interiors and professional chauffeurs enhance experience. It guarantees luxury travel."
  },
  {
    name: "Airport Transfer Service Navi Mumbai",
    description: "Airport transfer service Navi Mumbai ensures seamless pickup and drop services with professional drivers. This service is ideal for smooth airport travel. Flexible booking enhances convenience. It guarantees a stress-free experience."
  },
  {
    name: "Innova Airport Cab Service Navi Mumbai",
    description: "Innova airport cab service Navi Mumbai is perfect for families and groups seeking spacious and comfortable travel. Ample seating and luggage space enhance convenience. It ensures a comfortable airport transfer."
  },
  {
    name: "Sedan Airport Cab Service Navi Mumbai",
    description: "Sedan airport cab service Navi Mumbai is ideal for individuals and couples seeking economical travel. Sedans offer smooth rides and comfort. Professional drivers ensure safety. It ensures a relaxed journey."
  },
  {
    name: "SUV Airport Cab Service Navi Mumbai",
    description: "SUV airport cab service Navi Mumbai provides spacious and comfortable travel for families and groups. SUVs offer extra luggage space and better comfort. It ensures a comfortable airport journey."
  },
  {
    name: "Tempo Traveller Airport Service Navi Mumbai",
    description: "Tempo Traveller airport service Navi Mumbai is ideal for large groups and corporate travel. Spacious seating and group-friendly features make it perfect for airport transfers. It ensures a convenient group travel experience."
  }
],

tableData: [
  ["Navi Mumbai Airport Cab Service", "Navi Mumbai Airport Taxi Service"],
  ["Airport Cab Service Navi Mumbai", "Navi Mumbai Airport Taxi"],
  ["Navi Mumbai Airport Cab", "Book Cab Service for Navi Mumbai Airport"],
  ["Online Navi Mumbai Airport Cab Service", "Best Cab Service Navi Mumbai Airport"],
  ["Reliable Airport Cab Service Navi Mumbai", "Cheapest Cab Service Navi Mumbai Airport"],
  ["24x7 Navi Mumbai Airport Cab Service", "Late Night Airport Cab Service Navi Mumbai"],
  ["Early Morning Airport Taxi Navi Mumbai", "Corporate Cab Service Navi Mumbai Airport"],
  ["Luxury Airport Cab Service Navi Mumbai", "Airport Transfer Service Navi Mumbai"],
  ["Innova Airport Cab Service Navi Mumbai", "Sedan Airport Cab Service Navi Mumbai"],
  ["SUV Airport Cab Service Navi Mumbai", "Tempo Traveller Airport Service Navi Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Navi Mumbai Airport Cab Service",
    WhyChoosedescription: "Royal Route Cabs offers dependable cab service to and from Navi Mumbai Airport, ensuring smooth pickup and drop for all travelers."
  },
  {
    WhyChooseheading: "On-Time Airport Pickup with Flight Tracking",
    WhyChoosedescription: "We monitor flight timings to provide timely pickup even during delays, ensuring a hassle-free airport travel experience."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Navi Mumbai Airport cab service operates round the clock, perfect for late-night arrivals and early morning departures."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our drivers are well-trained, courteous, and experienced in airport routes, ensuring safe and comfortable travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing including tolls and parking charges with no hidden costs."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and sanitized regularly for a comfortable ride."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for group travel."
  },
  {
    WhyChooseheading: "Trusted Airport Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for reliable airport transfers in Navi Mumbai with punctual service and smooth experience."
  }
]

};

const faqData = [
  { question: "Do you provide cab service to Navi Mumbai Airport?", answer: "Yes, Royal Route Cabs offers reliable cab services for pickup and drop to Navi Mumbai Airport." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Navi Mumbai Airport cab service operates 24/7." },
  { question: "Do you provide airport pickup from all areas?", answer: "Yes, we provide pickup from Mumbai, Navi Mumbai, Thane, and nearby locations." },
  { question: "What is the average airport cab fare?", answer: "Airport cab fares typically range from ₹800 to ₹2500 depending on distance and vehicle type." },
  { question: "Do you track flight timings?", answer: "Yes, we track flights to ensure timely pickup even in case of delays." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book cab online?", answer: "Yes, you can easily book online or via phone for airport transfers." },
  { question: "Do you provide one-way airport drop?", answer: "Yes, we provide one-way and round-trip airport cab services." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended to ensure availability." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Karan Deshmukh",
    feedback: "Navi Mumbai Airport cab service with Royal Route Cabs was very punctual and smooth. The driver arrived on time and ensured a comfortable ride to the destination.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback: "Excellent airport cab experience in Navi Mumbai. The vehicle was clean, and the entire transfer was hassle-free and well-managed by Royal Route Cabs.",
    rating: 5
  }
];









  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai Airport Cab Service",
  "image": "https://www.royalroutecabs.com/assets/images/navi-mumbai-airport-cab-service.jpg", // replace if needed
  "description": "Book Navi Mumbai Airport cab service with Royal Route Cabs for safe, reliable, and on-time airport transfers. Available 24x7 with sedan, SUV, Innova, Ertiga, and tempo traveller options for pickup and drop services.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "999", // starting airport transfer fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/navi-mumbai-airport-cab-service"
  }
};






  return (
    <div>
<Helmet>
  <title>Navi Mumbai Airport Cab Service | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Navi Mumbai Airport cab service with Royal Route Cabs. 24x7 reliable airport pickup and drop with affordable fares, professional drivers, and comfortable vehicles."
  />

  <meta
    name="keywords"
    content="navi mumbai airport cab service, navi mumbai airport taxi service, airport cab service navi mumbai, navi mumbai airport taxi, navi mumbai airport cab, book cab service for navi mumbai airport, online navi mumbai airport cab service, best cab service navi mumbai airport, reliable airport cab service navi mumbai, cheapest cab service navi mumbai airport, 24x7 navi mumbai airport cab service, late night airport cab service navi mumbai, early morning airport taxi navi mumbai, corporate cab service navi mumbai airport, luxury airport cab service navi mumbai, airport transfer service navi mumbai, innova airport cab service navi mumbai, sedan airport cab service navi mumbai, suv airport cab service navi mumbai, tempo traveller airport service navi mumbai, safe airport cab service in navi mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/73.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaiairportcabservice;